export default __webpack_public_path__ + "static/media/mdrrmo_logo.73d6da2d.png";